module.exports = __webpack_public_path__ + "img/map_kobala.71240038.png";